import React from 'react'
import {connect} from 'react-redux'
import qrcode from 'qrcode'
import axios from 'axios'
import { WKError,Preload} from '../../../components'
import {renderMoney, TimeStream} from '../../../utils'

import '../../../css/page/NewPeopleReports.css'

import errorImg from '../../../images/no-source.png'
import ewmLeft from '../../../images/newPeople/ewm-left.png'
import ewmRight from '../../../images/newPeople/ewm-right.png'

class NewPeopleReports extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            init:false,
            has_received:false,
            channels:[],
            mp:null,
            coupon_info:null,
            qrcodeImg:null
        }
    }
    componentWillMount(){
        document.title = '新人报到大礼包'
    }
    componentWillReceiveProps(nextProps){
        let {subscribed} = nextProps.account
        let surplus = '';
        if(this.props.router.location.query.inviter_id){
            surplus = `?inviter_id=${this.props.router.location.query.inviter_id}`
        }
        axios.get(`/api/coupon/new_people/info${surplus}`)
        .then(res => {
                const data = res.data;
                if (data.code === 0 || data.code === 1) {
                    let resData = {
                        init: true,
                        has_received: data.data.has_received,
                        channels:data.data.channels,
                        mp:data.data.mp,
                        coupon_info:data.data.coupon_info
                    }

                    data.data.qrcode && this.toQrImg(data.data.qrcode)

                    //已关注 未领取 调用领取接口
                    if (!data.data.has_received) {
                         this.receiveCoupon()
                    }

                    this.setState(resData)

                    //微信分享sdk
                    this.props.dispatch({
                        type: 'UPDATE_SHARE_DATA',
                        payload: {
                            title: data.data.share_info.share_title,
                            desc: data.data.share_info.share_description,
                            imgUrl: data.data.share_info.share_icon,
                            type: 'link',
                            link: data.data.share_info.share_url,
                        }
                    });
                }
            }).catch((error) => {
            if (error.response) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: '网络连接出错。',
                        img: errorImg,
                        href: '/?st=wallet_404',
                        btn: '去首页看看'
                    }
                });
            }
        });

    }
    receiveCoupon(){
        const inviter_id = this.props.router.location.query.inviter_id
        let params = inviter_id ? `?inviter_id=${inviter_id}` : ''
        axios.post(`/api/coupon/new_people/accept${params}`)
        .catch((error) => {
        if (error.response) {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '网络连接出错。',
                    img: errorImg,
                    href: '/?st=wallet_404',
                    btn: '去首页看看'
                }
            });
        }
    });
    }
    toQrImg (str) {
        qrcode.toDataURL(str, {
            errorCorrectionLevel: 'M',
            margin: 2,
            type: 'image/png',
        }, (err, url) => {
            if (err) throw err
            this.setState({ qrcodeImg: url })
        })
    }

    //去使用按钮
    gotoUseTheCoupon() {
        if (this.props.router.location.query.inviter_id && this.props.router.location.query.inviter_id==='62148501') {
            window.location.assign(`/specials/coupon?bagid=8&inviter_id=62148501&is_hide_prize=1&is_new_people=1&wk_from=param_1`)
        }else{
            window.location.assign(`/specials/coupon?bagid=8&inviter_id=56139126&is_hide_prize=1&is_new_people=1&wk_from=param_1`)
        }
    }

    render(){
        const {account,error} = this.props
        const {init,has_received,channels,mp,coupon_info,qrcodeImg} = this.state;
        const coupon_price =  coupon_info && renderMoney(coupon_info.coupon_price).split('.')[0]

        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }

        if (!init) {
            return <Preload/>
        }
        return(
            <div className='new-people-page' style={{backgroundColor: '#ee443f'}}>
                <div className='top-img'>
                    {/* {account.subscribed && */}
                    <img
                        src='https://static-1253442168.image.myqcloud.com/picture/8173011_69bff43cb7954dd6aa6dc40cc8628840.jpg'
                        alt=""/>
                    {/* } */}
                    {/* {!account.subscribed &&
                    <img
                        src='https://static-1253442168.image.myqcloud.com/picture/8173011_84b76315fc64b00754ca9bb756905d95.jpg'
                        alt=""/>
                    } */}
                </div>
                <div className='new-people-page_main'>
    
                            <div className='follow_yes'>
                                <div className='gift-box'>
                                    <div className="title">
                                        <img src="https://static-1253442168.image.myqcloud.com/picture/8173011_219f039246451cfe16cb3efdc15d331e.jpg" alt=""/>
                                    </div>
                                    {/*<div className='tit'>{coupon_price}元无门槛现金券 x{coupon_info.coupon_count}张</div>*/}

                                    {/*<div className='cash-coupon'>*/}
                                        {/*<div className='left'><i>¥ </i><label>{coupon_price}</label></div>*/}
                                        {/*<div className="right">*/}
                                            {/*<div className="content">无门槛现金券 {coupon_info.coupon_count}张</div>*/}
                                            {/*<div className="desc">有效期至：{coupon_info.end_time && TimeStream(coupon_info.end_time)}</div>*/}
                                        {/*</div>*/}
                                    {/*</div>*/}

                                    <div className="coupon_List" onClick={()=>{window.location.href="/specials/coupon?bagid=8&inviter_id=56139126&is_hide_prize=1&is_new_people=1&wk_from=param_1"}}>
                                        <div className="coupon_List_item">
                                             <span><i>¥</i><p>{coupon_price}</p></span>
                                             <img src="https://static-1253442168.image.myqcloud.com/picture/8173011_324bbe1517947e0c420fd4d69425021e.jpg" alt=""/>
                                        </div>
                                        <div className="coupon_List_item">
                                            <span><i>¥</i><p>{coupon_price}</p></span>
                                            <img src="https://static-1253442168.image.myqcloud.com/picture/8173011_324bbe1517947e0c420fd4d69425021e.jpg" alt=""/>
                                        </div>

                                        <div className="coupon_List_item">
                                            <span><i>¥</i><p>{coupon_price}</p></span>
                                            <img src="https://static-1253442168.image.myqcloud.com/picture/8173011_324bbe1517947e0c420fd4d69425021e.jpg" alt=""/>
                                        </div>
                                    </div>

                                    <div className='use-coupon'><a onClick={()=>this.gotoUseTheCoupon()}>去使用</a></div>
                                </div>
                                <div className='gift-box'>
                                    <div className="title">
                                        <img src="https://static-1253442168.image.myqcloud.com/picture/8173011_652752d850c40db7800ed66896539c91.jpg" alt=""/>
                                    </div>
                                    {/**/}
                                    {
                                        channels && channels.map(item =>{
                                            return (
                                                <div className='course' key={item.id}>
                                                    <a href={`/channel/${item.id}`}>
                                                        <div className="give"></div>
                                                        <div className="course-img" style={{backgroundImage: `url(${item.cover_url})`}}></div>
                                                        <div className='course-main'>
                                                            <div className="course-tit">{item.name}</div>
                                                            <div className="bottom">
                                                                <label>¥ 99.00</label>
                                                                <span>免费听</span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            )
                                        })
                                    }
                                    <div className="tips">*可到个人中心-订单记录查看课程哦</div>
                                </div>
                            </div>           
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    error: state.error,
    account: state.account
}))(NewPeopleReports)



// WEBPACK FOOTER //
// ./src/pages/ActivityPage/NewPeopleReports/NewPeopleReports.js